import { Dropdown as Dropdowns } from 'primereact/dropdown';  

const Dropdownz = ({...rest}) => {

    return (
        <Dropdowns {...rest} />
    )

};

export default Dropdownz;